<ng-container *ngIf="auth.isAuthenticated$ | async">
  <button kendoButton icon="close" (click)="doLogOut()">
    <i class="fa-solid fa-right-from-bracket"></i>
    Log out
  </button>
</ng-container>